import {
    getInfoByCode,
    getUserOpenData,
    saveUserInfo,
    searchUserInfo,
    sendVerificationEmail, verifyEmail
} from '@/store/RequestApis/UserInfoApi'


const actions = {
    saveUserInfo({commit}, params) {
        return new Promise((resolve, reject) => {
            saveUserInfo(params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    searchUserInfo(id) {
        return new Promise((resolve, reject) => {
            searchUserInfo(id).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInfoByCode(id) {
        return new Promise((resolve, reject) => {
            getInfoByCode(id).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getUserOpenData(param) {
        return new Promise((resolve, reject) => {
            getUserOpenData(param).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sendVerificationEmail(param) {
        return new Promise((resolve, reject) => {
            sendVerificationEmail(param).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    verifyEmail(email, code) {
        return new Promise((resolve, reject) => {
            verifyEmail(email, code).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default actions